/**
 * Stories for 404 handle this
 */
/* eslint-disable local-rules/require-storybook-documentation */

import { Box } from '@zillow/constellation-10';

export const ContentWrapper = ({ children }: { children: React.ReactNode }) => (
    <Box
        css={{
            maxWidth: 'sizing.contentWidth',
            margin: '0 auto',
            padding: { base: 'xs', lg: 'lg' },
            paddingTop: 'xl',
            textAlign: { base: 'center', lg: 'left' },
            zIndex: 2,
            position: { lg: 'absolute' },
            top: { lg: 0 },
        }}>
        {children}
    </Box>
);
